import { brannanConfig } from '@apps/guest/packages/layout-engine/layouts/LayoutBrannan/LayoutBrannan.theme';
import { alohaConfig } from '@apps/guest/packages/layout-engine/layouts/LayoutAloha/LayoutAloha.theme';

export const layoutConfigs = {
  brannan: brannanConfig,
  aloha: alohaConfig,
} as const;
